import Hero from './components/Hero';
import CampaignStatus from './components/CampaignInfo';
import DonateNow from './components/DonateNow';
const config = require('./fundraiser-config');

function App() {
  return (
    <div className="flex flex-col justify-center items-center">
      <Hero image={config.featuredImage} alt={config.imageAlt} />
      <CampaignStatus />
      <h1 className="font-bold text-3xl">
        {config.name}
      </h1>
      <hr className="bg-gray-500 w-4/5 h-0.5 mt-2.5" />
      <div className="text-gray-700 w-11/12 m-5 flex flex-col items-center justify-center text-center">
        {config.description.map((paragraph, index) => {
          return <div key={index}>
            <p>{paragraph}</p>
            <br />
          </div>;
        })}
      </div>

      <DonateNow />
      <br />
    </div>
  );
}

export default App;
